import { ref } from 'vue'
import { post } from '@/api'

export const points = ref(0)

export async function updatePoints() {
  const res = await post('insurance/user/getUserPointByUserId', {
    userId: localStorage.getItem('userId'),
  })
  points.value = res.body.data.points
}

// 初始化积分值
export function initPoints() {
  const userPoints = +localStorage.getItem('userPoints')
  points.value = Number.isNaN(userPoints) ? 0 : userPoints
}
